import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { Category, Course, Profile } from './profiles.type';

@Injectable({
    providedIn: 'root'
})
export class ProfilesService {
    // Private
    private _categories: BehaviorSubject<Category[] | null> = new BehaviorSubject(null);
    private _course: BehaviorSubject<Course | null> = new BehaviorSubject(null);
    private _courses: BehaviorSubject<Course[] | null> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for categories
     */
    get categories$(): Observable<Category[]> {
        return this._categories.asObservable();
    }

    /**
     * Getter for courses
     */
    get courses$(): Observable<Course[]> {
        return this._courses.asObservable();
    }

    /**
     * Getter for course
     */
    get course$(): Observable<Course> {
        return this._course.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get categories
     */
    getCategories(): Observable<Category[]> {
        return this._httpClient.get<Category[]>('api/apps/academy/categories').pipe(
            tap((response: any) => {
                this._categories.next(response);
            })
        );
    }

    /**
     * Get courses
     */
    getCourses(): Observable<Course[]> {
        return this._httpClient.get<Course[]>('api/apps/academy/courses').pipe(
            tap((response: any) => {
                this._courses.next(response);
            })
        );
    }

    /**
     * Get courses
     */
    getProfiles(): Observable<Course[]> {
        return this._httpClient.get<Course[]>(environment.hostname + '/site/getprofiles').pipe(
            tap((response: any) => {
                this._courses.next(response);
            })
        );
    }


    /**
     * Get courses
     */
     getPortfolios(skill_ids): Observable<Course[]> {
        return this._httpClient.post<Course[]>(environment.hostname + '/site/getportfolios',  {skills: skill_ids}).pipe(
            tap((response: any) => {
                this._courses.next(response);
            })
        );
    }

    /**
     * Get course by id
     */
    getCourseById(id: string): Observable<Course> {
        return this._httpClient.get<Course>('api/apps/academy/courses/course', { params: { id } }).pipe(
            map((course) => {

                // Update the course
                this._course.next(course);

                // Return the course
                return course;
            }),
            switchMap((course) => {

                if (!course) {
                    return throwError('Could not found course with id of ' + id + '!');
                }

                return of(course);
            })
        );
    }
    /**
     * Get profile by id
     */
    getProfileById(id: string): Observable<Profile> {
        return this._httpClient.get<Profile>(environment.hostname + '/site/getprofile', { params: { id } }).pipe(
            map((profile) => {
                console.log(profile);
                // Update the course
                this._course.next(profile);

                // Return the course
                return profile;
            }),
            switchMap((profile) => {

                if (!profile) {
                    return throwError('Could not found profile with id of ' + id + '!');
                }

                return of(profile);
            })
        );
    }

    /**
     * Submit price quotation
     */
    submitPriceQuote(formData): Observable<any> {
        return this._httpClient.post<any>(environment.hostname + '/site/submitpricequote', formData)
            .pipe(
                map((result) => {
                    //  console.log(result);
                    // Update the course
                    //  this._course.next(result);

                    // Return the course
                    return result;
                }),
                switchMap((result) => {

                    if (!result) {
                        return throwError('Could not found profile with id of ' + + '!');
                    }

                    return of(result);
                })
            );
    }

    /**
     * Get courses
     */
     submitContactUs(formData): Observable<any> {
        return this._httpClient.post<any>(environment.hostname + '/site/contactus', formData)
            .pipe(
                map((result) => {
                    //  console.log(result);
                    // Update the course
                    //  this._course.next(result);

                    // Return the course
                    return result;
                }),
                switchMap((result) => {

                    if (!result) {
                        return throwError('Something went wrong ' + + '!');
                    }

                    return of(result);
                })
            );
    }

    scroll(el: HTMLElement) {
        el.scrollIntoView();
    }
}

